<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title">Utilização de vidas</span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="!isLoading || beneficiaryUsageData" class="indicator-total">Total: {{ beneficiaryUsageTotalValue() }}</div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading || beneficiaryUsageData" class="indicator-content-container">
    <mat-progress-spinner diameter="170" color="primary" mode="determinate" [value]="100" style="z-index: 1"></mat-progress-spinner>
    <mat-progress-spinner diameter="137" color="warn" mode="determinate" [value]="beneficiaryUsageDataValue()" style="z-index: 2"></mat-progress-spinner>
    <span class="value">{{ beneficiaryUsageDataValue() }}%</span>
  </div>
</div>
